<section class="savedViews__views" #viewsList>
  <div class="savedViews__border-wrapper">
    @if (draggedView !== null) {
      <div
        class="savedViews__cell--border"
        [style.marginTop.px]="linePosition"
      ></div>
    }
  </div>

  @if (ppType === ESavedView.PERSONAL) {
    @for (view of ppSavedViews.personal.views; track view; let i = $index) {
      <div
        class="savedViews__drag-row-container"
        (dragover)="onDragOver($event, i, view)"
        (drop)="onDrop($event)"
        (dragend)="onDragEnd()"
        >
        <div
          class="savedViews__drag-row"
          id="{{ 'itemRow-' + view.id }}"
          draggable="true"
          (dragstart)="onDragStart($event, i, view)"
          >
          <pp-icon
            [ppSrc]="EIconPath.ICON_DRAG_18"
            ppColor="grey-400"
            [ppDisplayContents]="true"
            ppClass="setSize18"
          ></pp-icon>
          <pp-saved-views-dropdown-row
            [ppView]="view"
            [ppType]="ppType"
            [ppViews]="ppSavedViews"
            [ppSecondaryDropdownService]="ppInjectedDropdownService"
          ></pp-saved-views-dropdown-row>
        </div>
      </div>
    }
  }

  @if (ppType === ESavedView.SHARED) {
    @for (view of ppSavedViews.shared.views; track view; let i = $index) {
      <div
        class="savedViews__drag-row-container"
        (dragover)="onDragOver($event, i, view)"
        (drop)="onDrop($event)"
        (dragend)="onDragEnd()"
        >
        <div
          class="savedViews__drag-row"
          [id]="'itemRow-' + view.id"
          draggable="true"
          (dragstart)="onDragStart($event, i, view)"
          >
          <pp-icon
            [ppSrc]="EIconPath.ICON_DRAG_18"
            ppColor="grey-400"
            [ppDisplayContents]="true"
            ppClass="setSize18"
          ></pp-icon>
          <pp-saved-views-dropdown-row
            [ppView]="view"
            [ppType]="ppType"
            [ppViews]="ppSavedViews"
            [ppSecondaryDropdownService]="ppInjectedDropdownService"
          ></pp-saved-views-dropdown-row>
        </div>
      </div>
    }
  }
</section>
